// extracted by mini-css-extract-plugin
export default {"card":"styles_card__0X4MX","tasks":"styles_tasks__kf3f+","pendencies":"styles_pendencies__qZN8n","roadmap":"styles_roadmap__BEvin","wrapper":"styles_wrapper__l1ZgQ"};